import { render } from "./LC_monitorPoints.vue?vue&type=template&id=09425f66&scoped=true"
import script from "./LC_monitorPoints.vue?vue&type=script&lang=js"
export * from "./LC_monitorPoints.vue?vue&type=script&lang=js"

import "./LC_monitorPoints.vue?vue&type=style&index=0&id=09425f66&lang=scss&scoped=scoped"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09425f66"]])

export default __exports__